import { render, staticRenderFns } from "./SalonFinish.vue?vue&type=template&id=737c526c"
import script from "./SalonFinish.vue?vue&type=script&lang=js"
export * from "./SalonFinish.vue?vue&type=script&lang=js"
import style0 from "./SalonFinish.vue?vue&type=style&index=0&id=737c526c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports